import { HighlightMatchLetters } from "../search/search-helpers";
import SearchSuggestions from "../search/search-suggestions";

export default class CountryAutocomplete extends SearchSuggestions {
    private itemList: OverseasLicenceConversionItem[]
    private filteredList: OverseasLicenceConversionItem[];
    private removeButton: HTMLButtonElement;
    private callback: (selectedCountry: OverseasLicenceConversionItem) => void;
    constructor(searchFormId: string, itemList: OverseasLicenceConversionItem[], callback: (selectedCountry: OverseasLicenceConversionItem) => void) {
        super(searchFormId)
        this.itemList = itemList;
        this.suggestionsContainer = this.searchFormContainer.querySelector(".autocomplete-wrapper");
        this.suggestionsList = this.suggestionsContainer.querySelector(".autocomplete-list");
        this.callback = callback;
    }
    AttachEventListeners() {
        let currentFocusIndex: number = 0;
        let timeout: NodeJS.Timeout | null = null;

        this.searchInput.addEventListener("input", () => {
            if (timeout !== null) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(() => {
                this.Search(this.searchInput.value);
            }, 500);
        })
        document.addEventListener("click", (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            if (!this.searchFormContainer.contains(target) && !this.suggestionsList.contains(target)) {
                this.ResetSuggestionsList();
            }
        });
        this.removeButton = this.searchFormContainer.querySelector(".remove-button");
        this.removeButton.addEventListener('click', () => {
            this.searchInput.value = "";
            this.removeButton.classList.remove("show");
            this.searchInput.focus();
            this.ResetSuggestionsList();
            this.DisplayResults.bind(this)(this.removeButton);
        })
        this.searchFormContainer.addEventListener('keydown', (e: KeyboardEvent) => {
            const allFocusableElements = Array.from(this.suggestionsList.querySelectorAll('button')) as HTMLElement[];
            switch (e.key) {
                case 'ArrowDown':
                    e.preventDefault(); // Prevent default scrolling behavior
                    if (allFocusableElements.length > 0) {
                        currentFocusIndex = (currentFocusIndex + 1) % allFocusableElements.length;
                        allFocusableElements[currentFocusIndex].focus();
                    }
                    break;
                case 'ArrowUp':
                    e.preventDefault(); // Prevent default scrolling behavior
                    if (allFocusableElements.length > 0) {
                        currentFocusIndex = (currentFocusIndex - 1 + allFocusableElements.length) % allFocusableElements.length;
                        allFocusableElements[currentFocusIndex].focus();
                    }
                    break;
                case 'Escape':
                    this.ResetSuggestionsList();
                    const activeEl = document.activeElement as HTMLElement;
                    if (allFocusableElements.includes(activeEl)) {
                        activeEl.blur();
                    }
                    this.searchInput.blur();
                    currentFocusIndex = -1;
                    break;
                case 'Tab':
                    const activeElem = document.activeElement as HTMLElement;

                    const isActiveElementFocusable = allFocusableElements.includes(activeElem);
                    const isLastFocusableElement = allFocusableElements.indexOf(activeElem) === allFocusableElements.length - 1;
                    const isNotSearchInputOrRemoveButton = activeElem !== this.searchInput && activeElem !== this.removeButton;

                    // Logic to close the autocomplete suggestion field when foxus shifts away
                    // If the active element is neither the search input nor remove button, 
                    // and it's not a focusable autocomplete option or it's the last option, reset the suggestion.
                    if (isNotSearchInputOrRemoveButton && (!isActiveElementFocusable || isLastFocusableElement)) {
                        this.ResetSuggestionsList();
                        currentFocusIndex = -1;
                    }
                    break;
            }
        });
    }
    async Search(query: string) {
        if (query != null) {
            if (query.length < 1) {
                this.ResetSuggestionsList();
                this.filteredList = this.itemList;
                this.removeButton.classList.remove("show");
                return;
            }
            this.LastSearch = query;
            this.filteredList = this.itemList.filter(x => x.countryDisplayName.toLowerCase().includes(query.toLowerCase()));
            this.UpdateResults();
            this.removeButton.classList.add("show");
        }
    }

    UpdateResults() {
        if (this.suggestionsContainer != null) {
            this.ResetSuggestionsList();
            if (this.suggestionItems.length > 0) this.suggestionItems = [];
            for (let i: number = 0; i < this.filteredList?.length; i++) {
                const suggestionItemClone: HTMLLIElement = this.suggestionItemTemplate.cloneNode(true) as HTMLLIElement;
                const suggestionItemButton: HTMLButtonElement = suggestionItemClone.querySelector('button');
                const suggestionItemTitle: HTMLDivElement = suggestionItemClone.querySelector(".result-item__title") as HTMLHeadingElement;
                if (suggestionItemClone != null &&
                    suggestionItemTitle != null) {
                    //Assign JSON values to template
                    suggestionItemClone.classList.remove('d-none');
                    suggestionItemClone.classList.remove('search-suggestions__template');
                    suggestionItemClone.classList.add('autocomplete-item');
                    const itemTitle = this.filteredList[i].countryDisplayName;
                    suggestionItemTitle.innerHTML = HighlightMatchLetters(this.LastSearch, itemTitle);
                    // new
                    suggestionItemButton.setAttribute("data-name", this.filteredList[i].countryName);
                    suggestionItemButton.setAttribute("data-displayname", this.filteredList[i].countryDisplayName);
                    suggestionItemButton.addEventListener('click', this.DisplayResults.bind(this))
                }

                this.suggestionItems.push(suggestionItemClone);
            }

            if (this.filteredList.length == 0) {
                this.ResetSuggestionsList();
            }
        }

        this.GenerateSuggestionsList();
        if (this.suggestionsContainer && this.suggestionItems.length > 0) {
            this.suggestionsContainer.classList.add('show');
            this.searchInput.setAttribute('aria-expanded', 'true');
        }
    }

    // Generate suggstions list
    GenerateSuggestionsList() {
        for (let i = 0; i < this.suggestionItems.length; i++) {
            this.suggestionsList.appendChild(this.suggestionItems[i]);
        }
    }
    ResetSuggestionsList() {
        this.suggestionsList.innerHTML = ''
        this.searchInput.setAttribute('aria-expanded', 'false');
        this.HideSuggestions();
    }
    DisplayResults(e: Event | HTMLButtonElement) {
        const selectedElement = (e instanceof Event ? e.target : e) as HTMLButtonElement;
        if (selectedElement.className == "remove-button") {
            this.callback(null);
        } else {
            const itemButton = selectedElement.closest('[data-name][data-displayname]') as HTMLButtonElement;
            const countryDisplayName = itemButton.getAttribute('data-displayname');
            this.searchInput.value = countryDisplayName;
            const selectedItem = this.itemList.find(x => x.countryDisplayName == countryDisplayName);
            this.callback(selectedItem);
        }
        this.ResetSuggestionsList();
        this.removeButton.focus();
    }
    
}